import React, { useState, useEffect } from 'react';
import Select from 'react-select'; // For React-Select dropdown
import WebsiteService from '../services/WebsiteService';
import BlogTable from '../component/table/BlogTable';
import { toast } from 'react-toastify';
import BlogCreationScreen from './blog/BlogCreationScreen';

const BlogDashboard = ({ user }) => {
  const [websites, setWebsites] = useState([]); // To store websites for the dropdown
  const [selectedWebsite, setSelectedWebsite] = useState(null); // Currently selected website
  const [currScreen, setCurrScreen]=useState(1);
  const [selectedBlog, setSelectedBlog] = useState(null);

  // Fetch websites on component load
  useEffect(() => {
    const fetchWebsites = async () => {
      try {
        const response = await WebsiteService.getAllWebsites(); // Replace with your API endpoint        
        const websiteOptions = response.map((site) => ({
          value: site.id,
          label: site.name,
        }));
        setWebsites(websiteOptions);
        setSelectedWebsite(websiteOptions[0]); // Default to the first website
      } catch (error) {
        toast.error(error.message || 'Failed to fetch websites.');
      }
    };
    fetchWebsites();
  }, []);

  const handleAddBlog=()=>{
    setSelectedBlog(null);
    setCurrScreen(2);
  };

  const handleEditBlog=(blog)=>{
    setSelectedBlog(blog);
    setCurrScreen(2);
  };

  return (
    <div>

    {/* Screen 1: Blog Dashboard */}
    {currScreen === 1 && (
      <>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h3>Blogs</h3>        
        <Select
          styles={{
            control: (base) => ({
              ...base,
              width: '300px', // Adjust the width as needed
            }),
          }}
          options={websites}
          value={selectedWebsite}
          onChange={setSelectedWebsite} // Update the selected website
          placeholder="Select a Website"
          isClearable
        />
        <button
          className="btn btn-primary"
          onClick={handleAddBlog} // Navigate to Blog Creation Screen
        >
          <i className="fa fa-plus me-2" />
          Add New Blog
        </button>
      </div>

      {/* Pass the selected website's ID to the BlogTable */}
      {selectedWebsite && 
        <BlogTable 
        websiteId={selectedWebsite.value}
        loginUser={user} 
        setSelectedBlog={(blog)=>handleEditBlog(blog)}
       />
       }

      </>
    )}

      {/* Screen 2: Blog Creation */}
      {currScreen === 2 && (<>
        <div className="d-flex justify-content-between align-items-center mb-4">
        <button
          className="btn btn-secondary"
          onClick={() => setCurrScreen(1)} // Navigate to Blog Creation Screen
        >
        <i className="fa fa-arrow-left me-2" />
          Go Back
        </button>       
        <Select
          styles={{
            control: (base) => ({
              ...base,
              width: '300px', // Adjust the width as needed
            }),
          }}
          options={websites}
          value={selectedWebsite}
          onChange={setSelectedWebsite} // Update the selected website
          placeholder="Select a Website"
          isClearable
        />
      </div>
        <BlogCreationScreen 
            blog={selectedBlog}
            selectedWebsite={selectedWebsite}
            setCurrScreen = {()=>setCurrScreen(1)}
            loginUser={user}
        />
      </>)}

    </div>
    
  );
};

export default BlogDashboard;
